import { cn } from "@/lib/utils";
import { getFormationsLabel } from "@/redux/loadedContent/loadedContentSlice";
import { useSelector } from "react-redux";

import { chemistryIcon } from "../../../../designSystemIcons";
import { star } from "../../../../figmaElements";
import { MetaRatingLogoSvg } from "../../../svgs/MetaRatingLogoSvg";

type Props = {
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave?: () => void;
  chemistry: number;
  formationId: string;
  metaRating: number;
  index?: number;
  bestMetaRating?: boolean;
  bestChemistry?: boolean;
  highlight?: boolean;
};

const SuggestedSquadBox = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  chemistry,
  formationId,
  metaRating,
  bestMetaRating,
  bestChemistry,
  highlight,
}: Props) => {
  const formationLabel = useSelector(getFormationsLabel(formationId));

  return (
    <button
      className={cn(
        "rounded-lg w-full max-w-[106px] hover:bg-white/20 text-secondary sb-large:text-xs p-2 flex flex-col justify-evenly items-center",
        highlight ? "bg-white/10 shadow-white-glow" : "bg-white/5",
      )}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="flex flex-row w-full justify-evenly gap-x-0.5">
        <div className="flex flex-col items-center gap-y-1">
          <div className="h-5 text-white">
            <MetaRatingLogoSvg bgColor="var(--color-gray-900)" />
          </div>
          <div
            className={cn(
              "flex items-center gap-x-0.5 text-xs px-1 rounded border border-transparent",
              bestMetaRating && "border-brand-meta-orange",
            )}
          >
            <span>{(metaRating || 0).toFixed(1)}</span>
            {bestMetaRating && (
              <span className="w-2 h-2 text-brand-meta-orange opacity-80">
                {star}
              </span>
            )}
          </div>
        </div>
        <div className="flex flex-col items-center gap-y-1">
          <div className="h-5">{chemistryIcon}</div>
          <div
            className={cn(
              "flex items-center gap-x-0.5 text-xs px-1 rounded border border-transparent",
              bestChemistry && "border-primary-light-blue",
            )}
          >
            {chemistry}
            {bestChemistry && (
              <span className="w-2 h-2 text-primary-light-blue opacity-80">
                {star}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="text-xs whitespace-nowrap">{formationLabel}</div>
    </button>
  );
};

export default SuggestedSquadBox;
